var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPoster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m55.82 31.18-10.63 21.2h21.26z",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m49.24 44.13-4.1501-8.2699-8.2998 16.55h8.4001",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m33.1 60.86h35.28",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m42.81 67.02h16.78",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m35.04 9.1501-18.03 16.78",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m83.33 73.76-18.04 16.78",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m65.07 8.9199 18.03 16.78",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m17.24 73.3 18.03 16.78",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(12)",
    d: "m27.46 12.43h45.39c4.2028 0 7.61 4.2028 7.61 7.61v59.36c0 4.2028-3.4072 7.61-7.61 7.61h-45.39c-4.2028 0-7.61-4.2028-7.61-7.61v-59.36c0-4.2028 3.4072-7.61 7.61-7.61z",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoster);
export default __webpack_public_path__ + "static/media/poster.ba4f79137833e14ed0ae6c4708f8465e.svg";
export { ForwardRef as ReactComponent };